import React from "react";
import PropTypes from "prop-types";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./style.scss";

const TitlePage = ({ category }) => {
  return (
    <div className="container">
      <div className="title">
        {category && category == 1 ? (
          <>
            <FontAwesomeIcon icon={faSearch} />
            <span>体験・ツアー</span>
          </>
        ) : category && category == 2 ? (
          <>
            <FontAwesomeIcon icon={faSearch} />
            <span>グルメ体験をネットで予約</span>
          </>
        ) : null}
      </div>
    </div>
  );
};
TitlePage.propTypes = {
  category: PropTypes.string,
};

export default TitlePage;
